const tile = "_35stad8haa";

export { tile };
import "./atom.tile.style.linaria.module.css";
//# sourceMappingURL=atom.tile.style.js.map
